/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useCallback, useRef, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Alert,
  IconButton,
  Paper,
  Portal,
  Snackbar,
  Stack,
  Typography,
  styled,
} from '@mui/material';
import { Copy } from 'react-feather';

const TerminalContainer = styled(Paper)(({ theme }) => ({
  backgroundColor: '#1e1e1e',
  color: '#d4d4d4',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  fontFamily: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
  height: '300px',
  overflowY: 'auto',
  border: '1px solid #333',
  marginTop: '15px',
}));

const LogText = styled(Typography)({
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all',
  fontSize: '0.875rem',
  lineHeight: '1.5',
});

const TerminalLog = ({ logs = 'No Logs', title = '' }) => {
  const logEndRef = useRef(null);
  const [copied, setCopied] = useState(false);

  const onCopy = useCallback(() => {
    setCopied(true);
  }, []);
  //
  const handleClick = () => {
    setCopied(true);
  };
  return (
    <TerminalContainer elevation={3}>
      <Portal>
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={copied}
          onClose={() => {
            setCopied(false);
          }}
        >
          <Alert severity="success">Copy to clipboard!</Alert>
        </Snackbar>
      </Portal>
      <Stack direction="row" justifyContent="space-between">
        <Typography sx={{ color: '#bad66e' }}>{title}</Typography>
        <CopyToClipboard onCopy={onCopy} text={logs}>
          <IconButton onClick={handleClick}>
            <Copy size={16} style={{ color: '#bad66e' }} />
          </IconButton>
        </CopyToClipboard>
      </Stack>

      <LogText component="div">
        {logs}
        <div ref={logEndRef} />
      </LogText>
    </TerminalContainer>
  );
};

export default TerminalLog;
